import { EmailAddressStep } from "./steps/EmailAddressStep";
import { EmailVerificationStep } from "./steps/EmailVerificationStep";
import { NamesStep } from "./steps/NamesStep";
import { PasswordStep } from "./steps/PasswordStep";
import { RegistrationFormSteps, RegistrationStepProps } from "./steps/StepModel";

export const RegistrationStep: React.FC<RegistrationStepProps> = (props: RegistrationStepProps) => {
  switch (props.currentStep) {
    case RegistrationFormSteps.EmailAddress:
      return <EmailAddressStep {...props} />;
    case RegistrationFormSteps.EmailVerification:
      return <EmailVerificationStep {...props} />;
    case RegistrationFormSteps.Password:
      return <PasswordStep {...props} />;
    case RegistrationFormSteps.Names:
      return <NamesStep {...props} />;
    default:
      return <></>;
  }
};
